//import React from 'react';

import './index.css';
import { createRoot } from "react-dom/client";
import App from './app';
import { ClerkProvider } from "@clerk/clerk-react";

const clerkPubKey = process.env.REACT_APP_PUBLIC_CLERK_PUBLISHABLE_KEY;

const root = createRoot(document.getElementById("root"));

if (!clerkPubKey) {
  console.error("Missing REACT_APP_PUBLIC_CLERK_PUBLISHABLE_KEY. Please set it in your .env and restart the dev server.");
  root.render(
    <div style={{
      fontFamily: "Arial, sans-serif",
      padding: "2rem",
      color: "#b00020"
    }}>
      <h2>Configuration Error</h2>
      <p>Missing Clerk publishable key. Set REACT_APP_PUBLIC_CLERK_PUBLISHABLE_KEY in your .env and restart the dev server.</p>
    </div>
  );
} else {
  root.render(
    <ClerkProvider
      publishableKey={clerkPubKey}
      localization={{
        signIn: {
          start: {
            title: "Marstrix Story Generator",
            subtitle: "",
          },
        },
      }}
    >
      <App />
    </ClerkProvider>
  );
}
